<template>
  <div></div>
</template>

<script>
import { isLocalId } from '@/utils/Id'

/**
 * Just redirect on desk editor
 */
export default {
  name: 'DeskViewer',
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    edit() {
      !isLocalId(this.id) && this.$emit('edit')
    }
  },
  created() {
    this.edit()
  }
}
</script>
